import React, { Component} from 'react';
import '../css/index.css';
import TV from '../commonjs/GITV-JD';
import keyListener from '../commonjs/keyListener';
import keyCodes from '../commonjs/keyCodes';
import RequestUrl from '../commonjs/urlConfiger';
import HttpUtil from '../commonjs/HttpUtil';
import $ from 'jquery';
import Store from '../commonjs/store';
import Data from '../config/data';
import Button from './button';
let _Gitv = window.gitv;
_Gitv && _Gitv.onInit();
// if(window.gitv) window.gitv.onInit();
export default class HomePage extends Component{
    constructor(props){
        super(props);
        this.state = {
            ifAgree:true
        }
    }

    root

    componentDidMount(){
        //初始化焦点
        // 进入页面时发pb ot=1
        this.getPingBack(RequestUrl.getPBOpt(1));
        _Gitv && _Gitv.setExitOnNextBack("true");
        this.root = window.FocusEngine.render(document.getElementById("homePage"));
        
        console.log("reqUrl : --"+Store.getValue("IFAGREE"));
        //焦点跑马灯效果
        if(Store.getValue("IFAGREE") == "true"){
            this.setState({
                ifAgree:true
            })
        }else if(Store.getValue("IFAGREE") == "false"){
            this.setState({
                ifAgree:false
            })
        }else {
            this.setState({
                ifAgree:true
            })
        }
        // this.root.on("focus", (e) => {

        // });
        // this.root.on("blur", (e) => {
        //     //离开时清除定时器并删除抖动样式
            
        // });
        //跳转
        this.root.on("ok", (e) => {
            let oId = e.target.id;
            if(oId === "agree"){
                this.setState({
                    ifAgree:true
                },()=>{
                    Store.setValue("IFAGREE","true");
                    // 点击同意时发pb ot=2
                    this.getPingBack(RequestUrl.getPBOpt(2));
                    _Gitv && _Gitv.onFinish();
                    // let pathJson = {
                    //     "action": "com.gitv.game.video.Play",
                    //     "extras": {
                    //         "colId": "802",
                    //         "pageId":"002029",
                    //         "pageName":"服务协议",
                    //         "pageProductName":"酷玩",
                    //         "pageProductLocation":"推荐位"
                    //     }

                    // }
                    // _Gitv && _Gitv.jumpIntent(JSON.stringify(pathJson));
                })
            }
            if(oId === "disagree"){
                // _Gitv && _Gitv.setExitOnNextBack("true");
                // if(window._APP) window._APP.setRoot("true");
                // 点击不同意时发pb ot=3
                this.getPingBack(RequestUrl.getPBOpt(3));
                this.setState({
                    ifAgree:false
                },()=>{
                    Store.setValue("IFAGREE","false");
                })
            }

        });

        keyListener.set(this.handleKeyDown);

    }

    thisY = 0    
    handleKeyDown = (keyCode) => {
        console.log(keyCode);
        // let thisY = $(".scrollBox").scrollTop();
        
        console.log(this.thisY);
        if(keyCode === keyCodes.up){
            this.thisY = this.thisY+80;
            if(this.thisY>=0){
                this.thisY = 0;
            }
            // console.log(this.thisY+50);
            // $(".scrollBox").scrollTop(this.thisY+50);
            $(".scrollBox").animate({top:this.thisY},200);
            
        }
        if(keyCode === keyCodes.down){
            this.thisY = this.thisY-80;
            // console.log(this.thisY);
            let thisH = document.getElementById("scrollBox").clientHeight;
            let bdH = document.getElementById("bd").clientHeight;
            console.log(thisH);
            console.log(bdH);
            if(this.thisY + thisH < bdH){
                this.thisY = bdH - thisH - 50;
            }
            $(".scrollBox").animate({top:this.thisY},200);
            
        }
        
    }

    getPingBack = (url) => {
        HttpUtil.get(url).then((json)=>{
            // console.log('pnl OK!' + json);
        }, (json)=>{
            // console.log('pnl fail!' + json);
        });
    }

    componentWillUnmount(){
        this.timer && clearTimeout(this.timer);
        this.timerClick && clearTimeout(this.timerClick);
    }

    render(){
        let cname = this.state.ifAgree == true ? "yes" : "no";
        return(
        <div className="homePage" id="homePage" data-role="Switch">
            <div className="head">服务协议</div>
            <div className="bd" id="bd">
                <div className="scrollBox" id="scrollBox">
                    <div className="userProtocol">
                        <div className="title-h">{Data.userProtocol.name}</div>
                        <div className="time">{Data.userProtocol.time}</div>
                        <div className="title-j">{Data.userProtocol.suppose}</div>
                        <div className="menu">
                        {
                            Data.userProtocol.menu.map((e,key)=>{
                                return <span>{e}</span>
                            })
                        }
                        </div>
                        {
                            Data.userProtocol.mainWords.map((e,key)=>{
                                return <div className="list">
                                    <div className="j-title">{e.title}</div>
                                    {   
                                        e.wordlist.map((e,i)=>{
                                            return <div className="j-txt">{e}</div>
                                        })
                                    }
                                    </div>
                            })
                        }
                    </div>
                    <div className="VIPProtocol">
                        <div className="title-h">{Data.VIPProtocol.name}</div>
                        <div className="time">{Data.VIPProtocol.time}</div>
                        <div className="j-title">{Data.VIPProtocol.preamble.title}</div>
                        {
                            Data.VIPProtocol.preamble.wordlist.map((e,key)=>{
                                return <div className="j-txt">{e}</div>
                                        
                            })
                        }
                        <div className="menu">
                        {
                            Data.VIPProtocol.menu.map((e,key)=>{
                                return <span>{e}</span>
                            })
                        }
                        </div>
                        {
                            Data.VIPProtocol.mainWords.map((e,key)=>{
                                return <div className="list">
                                    <div className="j-title">{e.title}</div>
                                    {   
                                        e.wordlist.map((e,i)=>{
                                            return <div className="j-txt">{e}</div>
                                        })
                                    }
                                    </div>
                            })
                        }

                    </div>
                    <div className="trail">银河互联网电视有限公司</div>
                </div>
            </div>
            <div className={"status "+cname}><span></span>我已阅读并同意上述《服务协议》</div>
            <Button cName="button agree" id="agree" title="同意" />
            <Button cName="button disagree" id="disagree" title="不同意" />
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/homepage.js